












































import { Vue, Component, Prop } from "vue-property-decorator";

@Component({
  components: {
    "brand-select": () =>
      import("@/components/app/admin/tenancy/selectBrandDropdown.vue")
  }
})
export default class UHeader extends Vue {
  // Props

  @Prop({ default: "" })
  public title!: string;

  @Prop({ default: null })
  public cta!: string;

  @Prop({ default: true })
  public ctaIf!: boolean;

  @Prop({ default: "button" })
  public ctaIs!: string;

  @Prop({ default: false })
  public ctaDisabled!: boolean;

  @Prop({ default: false })
  public ctaLoading!: boolean;

  @Prop({ default: false })
  public hasBrandSwitcher!: boolean;
}
